import React, { useEffect, useState } from "react";
import "./CategoryPage.css";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useCart } from "../Context/CartContext";
import { FaArrowLeft } from "react-icons/fa6";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

export default function CategoryPage() {
  const navigate = useNavigate();
  const { categoryName } = useParams();
  const { addToCart } = useCart();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  function formatCategoryName(name) {
    if (!name) return "";
    const withSpaces = name.replace(/([A-Z])/g, " $1");
    return withSpaces
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        let q;

        if (categoryName === "all") {
          q = collection(db, "products");
        } else {
          q = query(
            collection(db, "products"),
            where("category", "==", categoryName),
          );
        }

        const snapshot = await getDocs(q);

        const productData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setProducts(productData);
      } catch (error) {
        console.error("Error fetching products:", error);
      }

      setLoading(false);
    };

    fetchProducts();
  }, [categoryName]);

  if (loading) return <p>Loading products...</p>;

  return (
    <section className="category-page">
      <aside className="category-one">
        <div className="category-backarrow">
          <FaArrowLeft
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
        </div>

        <div className="category-name">
          {formatCategoryName(categoryName)} ({products.length} items)
        </div>
      </aside>

      <aside className="category-two">
        <article className="category-products-display">
          {products.map((v) => (
            <div className="display-products-category" key={v.id}>
              <Link to={`/product/${v.id}`} className="category-product-data">
                <div className="category-product-image">
                  <img src={v.images?.[0]} alt={v.name} />
                </div>

                <div className="category-product-name">{v.name}</div>

                <div className="category-product-price">
                  ₹{v.price}
                  {v.oldprice && (
                    <span className="oldprice">₹{v.oldprice}</span>
                  )}
                </div>
              </Link>

              <div className="category-addtocart">
                <button onClick={() => addToCart(v)}>Add to cart</button>
              </div>
            </div>
          ))}
        </article>
      </aside>
    </section>
  );
}
